import numeral from 'numeral';

type UnitType =
  | 'dollar'
  | 'dollar-2dp'
  | 'mmbtu'
  | 'tbtu'
  | 'm3'
  | 'percent'
  | 'percent-2dp'
  | 'knots'
  | 'dollarPerDay'
  | 'dollarPerMmbtu';

const FORMATTERS: { [s: string]: any } = {
  mmbtu: new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }),
  percent: new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 0,
  }),
  'percent-2dp': new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
};

export const sparkFormat = (
  val: number,
  type: UnitType = 'dollar',
  withUnit = true
) => {
  if (type === 'dollar') {
    let number;
    if (val >= 1000000) {
      number = numeral(val).format('$0.00a');
    } else {
      number = numeral(val).format('$0a');
    }
    return withUnit ? `${number}` : number;
  } else if (type === 'dollar-2dp') {
    const number = numeral(val).format('$0.00');
    return withUnit ? `${number}` : number;
  } else if (type === 'dollarPerMmbtu') {
    const number = numeral(val).format('$0.00');
    return withUnit ? `${number} /MMBtu` : number;
  } else if (type === 'm3') {
    const number = val.toLocaleString();
    return withUnit ? `${number} m³` : number;
  } else if (type === 'percent') {
    const number = FORMATTERS[type].format(val);
    return withUnit ? `${number.toLocaleString()}` : number.slice(0, -1);
  } else if (type === 'percent-2dp') {
    const number = FORMATTERS[type].format(val);
    return withUnit ? `${number.toLocaleString()}` : number.slice(0, -1);
  } else if (type === 'knots') {
    const number = val;
    return withUnit ? `${number} knots` : number;
  } else if (type === 'dollarPerDay') {
    const number = val.toLocaleString();
    return withUnit ? `$ ${number} /day` : number;
  } else if (type === 'mmbtu') {
    const number = FORMATTERS[type].format(val).toLowerCase();
    return withUnit ? `${number} MMBtu` : number;
  } else if (type === 'tbtu') {
    const number = val.toFixed(2);
    return withUnit ? `${number} TBtu` : number;
  }

  return '';
};
